import { ConstitutionExcelValidationError } from '../types/ConstitutionExcel';

const ERROR_TRANSLATION_KEYS: Record<
  ConstitutionExcelValidationError['code'],
  string
> = {
  SHEET_NOT_FOUND: 'ConstitutionExcelErrorSheetNotFound',
  NO_ROWS: 'ConstitutionExcelErrorNoRows',
  MISSING_NAME: 'ConstitutionExcelErrorMissingName',
  MISSING_CIF: 'ConstitutionExcelErrorMissingCif',
  MISSING_SHARES: 'ConstitutionExcelErrorMissingShares',
  INVALID_SHARES: 'ConstitutionExcelErrorInvalidShares',
  INVALID_EMAIL: 'ConstitutionExcelErrorInvalidEmail',
  DUPLICATED_CIF_CONFLICT: 'ConstitutionExcelErrorDuplicatedCifConflict',
  DUPLICATED_CIF_IN_TEMPLATE: 'ConstitutionExcelErrorDuplicatedCifInTemplate',
  UNKNOWN_HOLDING_CLASS: 'ConstitutionExcelErrorUnknownHoldingClass',
  SOCIETY_ALREADY_CONSTITUTED: 'ConstitutionExcelErrorSocietyAlreadyConstituted',
  INVALID_RANGE: 'ConstitutionExcelErrorInvalidRange',
  INCOMPLETE_RANGE: 'ConstitutionExcelErrorIncompleteRange',
  RANGE_SHARES_MISMATCH: 'ConstitutionExcelErrorRangeSharesMismatch',
  OVERLAPPING_RANGES: 'ConstitutionExcelErrorOverlappingRanges',
};

export const getConstitutionExcelValidationMessages = (
  errors: ConstitutionExcelValidationError[],
  t: (key: string, options?: Record<string, unknown>) => string
): string[] => {
  const messages = errors.map((error) => {
    const key = ERROR_TRANSLATION_KEYS[error.code];

    if (error.code === 'INVALID_EMAIL' && error.detail) {
      return `${t(key)} (${error.detail})`;
    }

    if (error.code === 'UNKNOWN_HOLDING_CLASS' && error.detail) {
      return `${t(key)} (${error.detail})`;
    }

    if (error.code === 'DUPLICATED_CIF_IN_TEMPLATE' && error.cif) {
      return `${t(key)} (${error.cif})`;
    }

    if (error.rowIndex) {
      return `${t(key)} (${t('ConstitutionExcelRow')} ${error.rowIndex})`;
    }

    return t(key);
  });

  return [...new Set(messages)];
};
